import TimeInput from "@/components/Common/TimeInput/TimeInput.vue";
import { dateFormat, formatToTime } from "@/helpers/eventHelper";
import momentJs from "moment";
import { cloneDeep } from "lodash";
import "./EventDates.scss";
import { DateTime } from "luxon";
import DurationInput from "@/components/Events/DurationInput/DurationInput.vue";
import EventSet from "@/components/Events/EventSet/EventSet.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import DateInputTimeSeparate from "@/components/Events/DateInputTimeSeparate/DateInputTimeSeparate.vue";

Date.prototype.withoutTime = function() {
  const d = new Date(this);
  d.setHours(0, 0, 0, 0);
  return d;
};
export default {
  name: "EventDates",
  props: [
    "editedEvent",
    "step",
    "position",
    "errorList",
    "isOwnedBySubPrincipal",
    "momentsLoading"
  ],
  components: { DateInputTimeSeparate, TimeInput, DurationInput, EventSet },
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    states: [
      "Bayern",
      "Baden-Württemberg",
      "Niedersachsen",
      "Berlin",
      "Brandenburg",
      "Bremen",
      "Hamburg",
      "Hessen",
      "Mecklenburg-Vorpommern",
      "Nordrhein-Westfalen",
      "Rheinland-Pfalz",
      "Saarland",
      "Sachsen",
      "Sachsen-Anhalt",
      "Schleswig-Holstein",
      "Thüringen"
    ],
    selectedTab: "",
    selectedMomentTab: "",
    eventSetDialog: false,
    momentEditDialog: false,
    showPastEvents: false,
    editedMoment: {
      all_day: false,
      arrival_description: "",
      description: "",
      price_description: "",
      duration: 0
    },
    momentJs,
    momentMap: new Map(),
    pickerEvents: [],
    togglePicker: false,
    lastDate: "",
    displayMomentSection: false,
    onlyAFewMoments: true,
    dateRefreshKey: 0,
    momentIndex: null,
    pickerTime: "12:00"
  }),
  methods: {
    setEndTime(editedObject, time) {
      const startProperty = editedObject.start ? "start" : "from";
      const endProperty = editedObject.start ? "end" : "to";

      if (!time) {
        editedObject[endProperty] = "";
        editedObject.duration = 0;
        return;
      }

      const [hour, minute] = time.split(":");

      editedObject[endProperty] = DateTime.fromISO(
        editedObject[startProperty]
      ).set({ hour, minute });
      //allow end time on the next day
      if (
        new Date(editedObject[startProperty]) >
        new Date(editedObject[endProperty])
      ) {
        editedObject[endProperty] = editedObject[endProperty].plus({ days: 1 });
      }
      editedObject.duration = this.calcDuration(
        editedObject[startProperty],
        editedObject[endProperty]
      );
      this.dateRefreshKey++;
    },
    setEntryTime(editedObject, time) {
      const [hour, minute] = time.split(":");
      const startProperty = editedObject.start ? "start" : "from";

      editedObject.entry = DateTime.fromISO(editedObject[startProperty]).set({
        hour,
        minute
      });

      this.dateRefreshKey++;
    },
    keepSaneDateHelper(editedObject) {
      const startProperty = editedObject.start ? "start" : "from";
      const endProperty = editedObject.end ? "end" : "to";
      if (!editedObject.all_day) {
        if (editedObject.duration === 1440) {
          editedObject.duration = 0;
        }
        // fix enddate to be bigger as startdate
        // but keep time of end date if possible
        if (
          new Date(editedObject[startProperty]) >
          new Date(editedObject[endProperty])
        ) {
          const end = DateTime.fromISO(editedObject[endProperty]);
          editedObject[endProperty] = DateTime.fromISO(
            editedObject[startProperty]
          )
            .set({ hour: end.toFormat("HH"), minute: end.toFormat("mm") })
            .toISO();
          if (
            new Date(editedObject[startProperty]) >
            new Date(editedObject[endProperty])
          ) {
            editedObject[endProperty] = editedObject[startProperty];
          }
        }
        return;
      }
      editedObject[startProperty] = DateTime.fromISO(
        editedObject[startProperty]
      )
        .set({ hour: 0, minute: 0 })
        .toISO();
      editedObject[endProperty] = DateTime.fromISO(editedObject[startProperty])
        .set({ hour: 23, minute: 59 })
        .toISO();
      editedObject.duration = 24 * 60;
    },
    keepSaneDate() {
      this.keepSaneDateHelper(this.editedEvent);
      this.pickerTime = DateTime.fromISO(this.editedEvent.start).toFormat(
        "HH:mm"
      );
    },
    keepSaneDateMoment() {
      this.keepSaneDateHelper(this.editedMoment);
    },
    async removeAllEvents() {
      const isConfirmed = await this.$confirm(
        "Wollen sie wirklich alle weiteren Termine entfernen?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        this.editedEvent.deleteAllMoments = true;
        this.momentsForEvent = [];
      }
    },
    async removeMoment(moment) {
      const isConfirmed = await this.$confirm(
        "Wollen sie wirklich folgenden Termin entfernen?: " +
          dateFormat(moment.from),
        confirmWarningConfig
      );
      if (isConfirmed) {
        this.editedEvent.deleteMoments.push(moment);
        this.momentsForEvent = this.momentsForEvent.filter(
          m => m._id !== moment._id
        );
      }
    },
    checkIfOneDateIsInPast() {
      //is the 2nd date in the past? (the first is the main date which is not in the list below)
      let start = new Date(this.momentsForEvent?.[1]?.from);
      const now = new Date();
      if (start < now) return true;
    },
    openMomentDialog(momentToEdit, index) {
      this.momentIndex = index;
      if (!momentToEdit?.from) momentToEdit.from = this.editedEvent.start;
      if (!momentToEdit.duration)
        momentToEdit.duration =
          this.calcDuration(momentToEdit.from, momentToEdit.to) || 0;
      this.editedMoment = cloneDeep(momentToEdit);
      this.setOwnChannelMomentFields();
      this.momentEditDialog = true;
    },
    calcDuration(from, to) {
      const duration = DateTime.fromISO(to).diff(
        DateTime.fromISO(from),
        "minutes"
      );
      return duration.minutes;
    },
    setOwnChannelMomentFields() {
      const standardChannels = ["web", "print", "app", "print2"];
      const selectedOwnChannels = this.editedEvent.channels.filter(
        channel => !standardChannels.includes(channel)
      );
      if (selectedOwnChannels?.length) {
        selectedOwnChannels.forEach(channel => {
          if (!this.editedMoment.alternative_content) {
            this.editedMoment.alternative_content = {
              web: {
                description: "",
                short_description: ""
              },
              app: {
                description: "",
                short_description: ""
              },
              print: {
                description: "",
                short_description: ""
              },
              print2: {
                description: "",
                short_description: ""
              },
              [channel]: {
                description: "",
                short_description: ""
              }
            };
          }
          if (!this.editedMoment.alternative_content?.[channel]) {
            this.editedMoment.alternative_content[channel] = {
              description: "",
              short_description: ""
            };
            return;
          }
          if (!this.editedMoment.alternative_content?.[channel]?.description) {
            this.editedMoment.alternative_content[channel].description = "";
          }
          if (
            !this.editedMoment.alternative_content?.[channel]?.short_description
          ) {
            this.editedMoment.alternative_content[channel].short_description =
              "";
          }
        });
      }
    },
    async closeMomentDialog() {
      this.editedMoment = {};
      this.momentEditDialog = false;
      this.momentIndex = null;
    },
    async saveMoment(moment) {
      if (!moment) moment = this.editedMoment;
      // Build to-Date
      moment.to = DateTime.fromISO(moment.from).plus({
        minutes: moment.duration || 0
      });
      const momentsArray = this.momentsForEvent;
      // get correct index of edited moment
      const indexOfMoment = momentsArray.findIndex(
        item => item._id === moment._id
      );
      if (indexOfMoment >= 0) {
        moment.updated = true;
        momentsArray.splice(indexOfMoment, 1, moment);
        this.momentsForEvent = momentsArray;
      } else {
        momentsArray.push(moment);
        this.momentsForEvent = momentsArray;
      }
      this.momentIndex = null;
      await this.closeMomentDialog();
    },
    destructTimeString(timeString) {
      if (timeString) {
        const time = timeString.split(":");

        const hours = parseInt(time?.[0] ?? 12);
        const minutes = parseInt(time?.[1] ?? 0);
        return { hours, minutes };
      } else return { hours: 0, minutes: 0 };
    },
    dateFormat,
    formatToTime,
    addEventSetToEvent(data) {
      this.momentsForEvent = data;
    },
    allowedDates(date) {
      //block past dates
      if (new Date(date) < new Date()) return false;
      return true;
    },
    addDates() {
      const startTime = DateTime.fromISO(this.editedEvent.start);
      let [hours, mins] = this.pickerTime.split(":");
      const hour = parseInt(hours) || 12;
      const minute = parseInt(mins) || 0;
      let moments = this.pickerEvents
        .map(m => {
          let from = DateTime.fromJSDate(new Date(m));
          // if the date is the same as the main date, skip it
          if (startTime.toJSON() === from.set({ hour, minute }).toJSON()) {
            return;
          }
          return {
            from: from.set({ hour, minute }).toJSON(),
            to: from
              .set({ hour, minute })
              .plus({
                minutes: this.editedEvent.duration
              })
              .toJSON(),
            all_day: this.editedEvent.all_day
          };
        })
        .filter(m => m);
      const getUtcIso = date =>
        DateTime.fromISO(date)
          .toUTC()
          .toJSON();
      const alreadyPresent = this.momentsForEvent.map(m => getUtcIso(m.from));
      this.momentsForEvent = [
        ...this.momentsForEvent,
        ...moments.filter(m => !alreadyPresent.includes(getUtcIso(m.from)))
      ].sort(this.sortDateFunc);
      this.pickerEvents = [];
      this.togglePicker = false;
    },
    sortDateFunc(a, b) {
      return new Date(a.from) - new Date(b.from);
    },
    endBeforeStartCheck(obj) {
      let start = obj?.start;
      let end = obj?.end;
      if (!obj?.start) {
        start = obj?.from;
        end = obj?.to;
      }
      if (!start || !end) return false;
      return new Date(start) > new Date(end);
    },
    entryAfterStartEndCheck(obj) {
      const entry = obj?.entry;
      let start = obj?.start;
      let end = obj?.end;
      if (!obj?.start) {
        start = obj?.from;
        end = obj?.to;
      }
      if (!start || !end || !entry) return false;
      return (
        new Date(start) < new Date(entry) || new Date(end) < new Date(entry)
      );
    }
  },
  computed: {
    invalidMainDate() {
      if (this.dateRefreshKey) {
        // forces computed refresh on change of key
      }

      return !this.editedEvent.start;
    },
    momentToString() {
      return new Date(this.editedMoment.to).toLocaleString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      });
    },
    momentEntryString() {
      return new Date(this.editedMoment.entry).toLocaleString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      });
    },
    eventEndString() {
      return new Date(this.editedEvent.end).toLocaleString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      });
    },
    eventEntryString() {
      return new Date(this.editedEvent.entry).toLocaleString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      });
    },
    isDateError() {
      return !this.editedEvent?.start;
    },
    endBeforeStart() {
      return this.endBeforeStartCheck(this.editedEvent);
    },
    entryBeforeStartEnd() {
      return this.entryAfterStartEndCheck(this.editedEvent);
    },
    entryBeforeStartEndMoment() {
      return this.entryAfterStartEndCheck(this.editedMoment);
    },
    endBeforeStartMoment() {
      return this.endBeforeStartCheck(this.editedMoment);
    },
    eventMainDateIsAcrossDays() {
      if (!this.editedEvent.start) return false;
      const start = new Date(this.editedEvent.start);
      const end = new Date(this.editedEvent.end);
      return start.withoutTime() < end.withoutTime();
    },
    momentDateIsAcrossDays() {
      if (!this.editedMoment.from) return false;
      const start = new Date(this.editedMoment.from);
      const end = new Date(this.editedMoment.to);
      return start.withoutTime() < end.withoutTime();
    },
    momentFromIsNotUnique() {
      if (new Date(this.editedMoment.from) === new Date(this.editedEvent.start))
        return true;
      return (
        this.momentsForEvent
          .filter(m => m._id !== this.editedMoment._id)
          .filter(m => m.from === this.editedMoment.from).length > 0
      );
    },
    selectedChannels() {
      const standardChannels = this.$store.state.eventConfig?.standard_channels?.filter(
        channel => this.editedEvent?.channels?.includes(channel.value)
      );
      const ownChannels = this.$store.state.eventConfig?.own_channels?.filter(
        channel => this.editedEvent?.channels?.includes(channel.value)
      );
      return standardChannels.concat(ownChannels);
    },
    momentTabs() {
      let tabs = ["Beschreibung"];
      this.editedEvent.channels.forEach(c => {
        const found = this.selectedChannels.find(v => v.value === c);
        if (found) {
          tabs.push("Beschreibung (" + found.title + ")");
        }
      });
      tabs.push("Anreise und Preise");
      return tabs;
    },
    momentsForEvent: {
      get() {
        const sorted = this.$store.state.momentsForEvent.sort(
          this.sortDateFunc
        );
        if (!sorted.length) return [];
        this.lastDate = sorted?.slice(-1)?.[0]?.from;
        return sorted;
      },
      set(newValue) {
        this.$store.state.momentsForEvent = newValue.sort(this.sortDateFunc);
      }
    },
    allMoments() {
      let moms = [...this.momentsForEvent];
      // remove mainMoment
      moms = moms.filter(
        m => !m.mainMoment && m.from !== this.editedEvent.start
      );

      // dont remove past moments to prevent no 'Alte Termine anzeigen' button

      return moms.map(m => {
        m.past = new Date(m.from) < new Date();
        return m;
      });
    },
    filteredMoments() {
      let moms = [...this.momentsForEvent];
      // remove mainMoment
      moms = moms.filter(
        m => !m.mainMoment && m.from !== this.editedEvent.start
      );
      // hide past events
      if (!this.showPastEvents)
        moms = moms.filter(m => new Date(m.from) > new Date());
      // add past flag
      return moms.map(m => {
        m.past = new Date(m.from) < new Date();
        return m;
      });
    },
    visibleMoments() {
      // limit to 15 moments by default
      return this.onlyAFewMoments
        ? this.filteredMoments.slice(0, 15)
        : this.filteredMoments;
    },
    hasMultipleEventDates() {
      const multiple = this.allMoments?.length > 0;
      this.displayMomentSection = multiple;
      return multiple;
    },
    momentsEditable() {
      return !this.isOwnedBySubPrincipal;
    }
  },
  watcher: {
    momentsForEvent(newValue) {
      if (newValue?.length > 1) this.displayMomentSection = true;
    }
  },
  async mounted() {
    this.keepSaneDate();
  }
};
